
export class TrProgressButton {

    private button: any;
    private options: any = {
        statusTime : 3500,
    };

    private progress: any;
    private progressProp: any;

    constructor(buttonElement: any, options: any) {
        this.button = buttonElement;
        $(buttonElement)
            .addClass('progress-button');
        this.options = Object.assign( {}, this.options );
        Object.assign( this.options, options );
        this.init();
    }

    public init() {
        this.validate();
        // create structure
        this.create();
        // init events
        this.initEvents();
    }

    public initEvents() {

        // $(this.button).click(() => {
        //     // disable the button
        //     this.button.setAttribute( 'disabled', '' );
        //     // add class state-loading to the button (applies a specific transform to the button depending which data-style is defined - defined in the stylesheets)
        //     this.progress.classList.add('notransition');
        //     this.button.classList.add('state-loading' );

        //     if( typeof this.options.callback === 'function' ) {
        //         this.options.callback( this );
        //     }
        //     else {
        //         this.setProgress( 1 );
        //     }

        //     return true;
        // });

    }

    public start() {
        // disable the button
        this.button.setAttribute( 'disabled', '' );
        // add class state-loading to the button (applies a specific transform to the button depending which data-style is defined - defined in the stylesheets)
        this.progress.classList.add('notransition');
        this.button.classList.add('state-loading' );

        if ( typeof this.options.callback === 'function' ) {
            this.options.callback( this );
        } else {
            this.setProgress( 1 );
        }
    }

    public setProgress(val: number) {
        this.progress.style[ this.progressProp ] = 100 * val + '%';
    }

    public enable() {
        $(this.button)
            .removeAttr('disabled');
    }

    public create() {

        const textEl = document.createElement( 'span' );
        textEl.className = 'content';
        textEl.innerHTML = this.button.innerHTML;
        const progressEl = document.createElement( 'span' );
        progressEl.className = 'progress';

        const progressInnerEl = document.createElement( 'span' );
        progressInnerEl.className = 'progress-inner';
        progressEl.appendChild( progressInnerEl );
        // clear content
        this.button.innerHTML = '';

        if (this.button.getAttribute( 'data-perspective' ) !== null ) {
            const progressWrapEl = document.createElement( 'span' );
            progressWrapEl.className = 'progress-wrap';
            progressWrapEl.appendChild( textEl );
            progressWrapEl.appendChild( progressEl );
            this.button.appendChild( progressWrapEl );
        } else {
            this.button.appendChild( textEl );
            this.button.appendChild( progressEl );
        }

        // the element that serves as the progress bar
        this.progress = progressInnerEl;

        // property to change on the progress element
        if (this.button.getAttribute( 'data-horizontal') !== null ) {
            this.progressProp = 'width';
        } else if (this.button.getAttribute( 'data-vertical' ) !== null ) {
            this.progressProp = 'height';
        }

        this.enable();
    }

    public validate() {

        if (this.button.getAttribute( 'data-style' ) === null) {
            this.button.setAttribute( 'data-style', 'fill' );
        }
        if (this.button.getAttribute( 'data-vertical' ) === null && this.button.getAttribute( 'data-horizontal' ) === null) {
            this.button.setAttribute( 'data-horizontal', '' );
        }
    }

    public complete() {
        this.setProgress(1);
    }

    public stop(status: number = 200) {
        setTimeout( () => {
            // fade out progress bar
            this.progress.style.opacity = 0;
            const onEndTransFn = function( ev ) {
                // if( support.transitions && ev.propertyName !== 'opacity' ) return;
                this.removeEventListener( 'transition', onEndTransFn );
                this.progress.classList.add('notransition');
                this.progress.style[ this.progressProp ] = '0%';
                this.progress.style.opacity = 1;
            };

            this.progress.addEventListener( 'transition', onEndTransFn );

            // add class state-success to the button
            if ( typeof status === 'number' ) {
                const statusClass = status >= 0 ? 'state-success' : 'state-error';
                this.button.classList.add(statusClass);
                // after options.statusTime remove status
                setTimeout( () => {
                    this.button.classList.remove(statusClass);
                    this.enable();
                }, this.options.statusTime );
            } else {
                this.enable();
            }
            // remove class state-loading from the button
            this.button.classList.remove('state-loading');
        }, 100 );
    }
}
